<template>

    <accordion-input :accordion="accordion" :spacing="spacing" :open="open">
        <template #label>

            <div class="font-medium text-gray-600">{{ label }}</div>

        </template>
        <template #content>

            <small
                v-if="instruction"
                class="block mb-3 text-gray-500 text-muted">{{ instruction }}</small>

            <div class="inline-flex mt-1">

                <button
                    v-for="item in items"
                    :class="{ selected: item.value === currentValue }"
                    class="focus:outline-none"
                    @click="setValue(item.value)">{{ item.label !== undefined ? item.label : item.value }}
                </button>

            </div>

        </template>
    </accordion-input>

</template>

<script>

import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {

    components: {
        AccordionInput,
    },

    props: {

        label: {
            type: String,
            required: true,
        },
        instruction: String,

        spacing: {
            horizontal: {
                type: Boolean,
                default: true
            },
            vertical: {
                type: Boolean,
                default: true
            }
        },

        accordion: {
            type: Boolean,
            default: true
        },

        open: {
            type: Boolean,
            default: null
        },

        options: {
            type: Object,
            required: true,
        },
        optionsProperty: {
            required: true,
        },

        items: {
            type: Array,
            required: true,
        },

        defaultValue: {},
    },

    data() {
        return {
            isOpen: this.open || false,
        }
    },

    created()
    {
        if( !this.options[this.optionsProperty] ) {
            this.$set(this.options, this.optionsProperty, this.defaultValue);
        }
    },

    methods: {

        setValue(value)
        {
            // Set in options.
            this.$set(this.options, this.optionsProperty, value);

            // Emit for whoever wants to know.
            this.$emit('valueChange');
        }

    },

    computed: {

        currentValue()
        {
            // Get value from options.
            let value = this.options[this.optionsProperty];

            // Use value of default value?
            return value === undefined ? this.defaultValue : value;
        },

    },

}

</script>

<style lang="scss" scoped>

button {
    @apply bg-transparent py-2 px-4 border;
    border-color: #3899ec;
    color: #3899ec;
    cursor: pointer;

    &:not(:last-child) {
        @apply border-r-0;
    }

    &:hover,
    &.selected {
        @apply text-white border-transparent;
        background: #3899ec;
    }

}

</style>
